/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { getUsers } from '../fn/users/get-users';
import { GetUsers$Params } from '../fn/users/get-users';
import { UserListResponse } from '../models/user-list-response';


/**
 * Public Users API
 */
@Injectable({ providedIn: 'root' })
export class UsersService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getUsers()` */
  static readonly GetUsersPath = '/api/v2/users';

  /**
   * List users for the current tenant.
   *
   * Returns a paginated list of users belonging to the authenticated tenant. Service accounts and API-only users are excluded.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getUsers()` instead.
   *
   * This method doesn't expect any request body.
   */
  getUsers$Response(params?: GetUsers$Params, context?: HttpContext): Observable<StrictHttpResponse<UserListResponse>> {
    return getUsers(this.http, this.rootUrl, params, context);
  }

  /**
   * List users for the current tenant.
   *
   * Returns a paginated list of users belonging to the authenticated tenant. Service accounts and API-only users are excluded.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getUsers$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getUsers(params?: GetUsers$Params, context?: HttpContext): Observable<UserListResponse> {
    return this.getUsers$Response(params, context).pipe(
      map((r: StrictHttpResponse<UserListResponse>): UserListResponse => r.body)
    );
  }

}
